module.exports = __webpack_public_path__ + "img/R03_04.90cfe3e0.jpg";